<template>
  <div class="row">
    <div class="col-12 cover" @mouseover="coverUploadBody = true"
         @mouseleave="coverUploadBody = false">
      <div class="cover-upload-widget">
        <div class="cover-upload-body">

          <div v-if="imageStatus===1" class="img-avatar skeleton covers"></div>

          <div
            v-if="imageStatus === 0"
            @dragover.prevent
            @drop.prevent
            @drop="onFileDrop"
            @dragenter="onDragEnter"
            @dragleave="onDragLeave"
            class="cover-upload-area"
            :class="{ 'drag-state-active': dragEnterOnUploadArea }"
          >
            <input
              type="file"
              hidden
              multiple
              :name="'uploadFieldName'"
              @change="onSelectImage($event)"
              accept="image/*"
              id="cover-upload"
              class="input-file"
            />
            <div v-show="coverUploadBody" class="cover-upload-label">Add a Cover Image [Recommended size: 1240px x 200px]</div>
            <div v-show="coverUploadBody" class="cover-upload-label">Drag and drop your image here or click here</div>
            <div v-show="coverUploadBody"  class="cover-upload-seperator"></div>
            <div v-show="coverUploadBody" class="cover-upload-footer">
              <ButtonElement @click="activateFileUploadWindow" class="btn-grey-light m-0">
                Browse
              </ButtonElement>
            </div>
          </div>

          <div v-if="isNew && imageStatus===2" class="cover-upload-preview">
            <img class="cover-preview" id="cover-preview" :src="uploadedFileData" alt="" srcset="" />
          </div>
          <div v-if="!isNew && imageStatus===2" class="cover-upload-preview">
            <img class="cover-preview" id="cover-preview" :src="imageUrl" alt="" srcset="" v-on:error="onImageError()"/>
          </div>

          <div class="cover-upload-footer cancel-upload"
               :class="{ 'footer-to-right mt-3': imageStatus===2 }">
            <ButtonElement v-if="imageStatus===2" @click="removeImage()"
                           :class="'btn-grey-light'">
              Remove Image
            </ButtonElement>
            <ButtonElement v-if="imageStatus===2 && isNew" @click="startUpload" class="btn--ms btn--accent">
              Save
            </ButtonElement>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ButtonElement from '@shared/components/elements/button/button.element.vue'
import { CommonNs } from '@shared/types'
import {useGeneralStore} from "@shared/stores/general.store";
import {mapStores} from "pinia";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'CoverUploadWidget',
  components: { ButtonElement },
  props: {
    imageKey: {
      type: String,
      required: true
    }
  },
  emits: ['saveImage', 'removeImage'],
  computed: {
    ...mapStores(useGeneralStore),
    imageUrl (): string {
      if (this.imageKey) {
        return `${this.imageKey}/cover`
      } else {
        return ''
      }
    }
  },
  data () {
    return {
      // imageUrl: '',
      selectedFile: {} as CommonNs.ImageData,
      uploadedFileData: '',
      isNew: false,

      /** 0: NotExists | 1:Loading | 2:Loaded */
      imageStatus: 0,

      dragEnterOnUploadArea: false,
      coverUploadBody: false,
      imageTypes: ['image/png', 'image/gif', 'image/bmp', 'image/jpeg']
    }
  },
  beforeMount () {
    if (this.imageKey) {
      this.imageStatus = 2
      // this.imageStatus = 1;
      // store.dispatch('actionGetCompanyCover', this.imgKey)
      //   .then((response) => {
      //     this.imageFileData = `data:image/jpg;base64,${response}`;
      //     this.imageStatus = 2;
      //     this.isNew = false;
      //   }).catch(() => this.imageStatus = 0);
    }
  },
  methods: {
    onImageError () {
      this.imageStatus = 0
    },
    activateFileUploadWindow () {
      document.getElementById('cover-upload')?.click()
    },
    removeImage () {
      this.uploadedFileData = ''
      this.imageStatus = 0
      this.isNew = false
      this.selectedFile = {} as CommonNs.ImageData
      this.$emit('removeImage')
    },
    startUpload () {
      const img = document.getElementById('cover-preview') as HTMLImageElement
      const fileData = this.dataURIToBlob(img.src)
      this.selectedFile.file = fileData
      this.$emit('saveImage', this.selectedFile)
    },
    onDragEnter () {
      this.dragEnterOnUploadArea = true
    },
    onDragLeave () {
      this.dragEnterOnUploadArea = false
    },
    onFileDrop (event: any) {
      const { files } = event.dataTransfer.files
      if (
        files && files[0] &&
        this.imageTypes.includes(files[0].type)
      ) {
        this.loadImage(files)
      }
    },
    onSelectImage (event: any) {
      const { files } = event.target
      if (files && files[0]) {
        this.loadImage(files)
      }
    },
    loadImage (files: any) {
      if (files[0].size > 5242700) {
        toast.warning('Maximum image size allowed is 5 MB')
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        this.uploadedFileData = e.target?.result as any
      }
      reader.readAsDataURL(files[0])

      this.selectedFile = { name: files[0].name, type: files[0].type } as CommonNs.ImageData
      this.imageStatus = 2
      this.isNew = true
    },
    dataURIToBlob (dataURI: string) {
      const splitDataURI = dataURI.split(',')
      const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
      const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

      const ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i)

      return new Blob([ia], { type: mimeString })
    }
  }
})
</script>

<style lang="scss" scoped>
.dropdown-menu {
  width: 300px;
}

.cover-upload-widget {

  .cover-upload-body {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    display: none;

    .cover-upload-area {
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;
      width: 100%;
      height: 190px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      &.drag-state-active {
        background: var(--neutral-100);
      }

      .cover-upload-label {
        font-size: var(--fs-14);
        text-align: center;
        color: var(--text-neutral);
        pointer-events: none;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .cover-upload-preview {
      width: 100%;
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("../../../../assets/images/upload-dropzone-bg.png");
      background-size: contain;
      background-repeat: repeat;
      background-position: center center;
      overflow: hidden;

      .cover-preview {
        height: 100%;
        max-width: 100%;
        overflow: hidden;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
      }
    }

    .cover-upload-crosshair {
      position: absolute;
      border: 1px dashed var(--accent-100);
      width: 99%;
      height: 95%;
    }
  }

  .cover-upload-seperator {
    font-size: var(--fs-14);
    text-align: center;
    color: var(--text-neutral);
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5px;
  }

  .cover-zoom-slider-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px 40px;
    position: absolute;

    .cover-zoom-slider {
      width: 180px;
      -webkit-appearance: none;
      appearance: none;
      height: 5px;
      border-radius: $br-lg-oval;
      background: var(--neutral-100);
      outline: none;

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 15px;
        height: 15px;
        border-radius: $br-circle;
        opacity: 1;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        background: var(--light-100);
        cursor: pointer;
      }
    }

    .slider-button {
      padding: 5px 13px;
      display: flex;
      align-items: center;
      font-size: var(--fs-14);
    }
  }

  .cover-upload-footer {
    display: flex;
    justify-content: center;
    align-items: center;

    &.cancel-upload {
      position: absolute;
      right: 40px;
      bottom: 20px;
    }

    &.footer-to-right {
      justify-content: flex-end;
    }
  }
}

.cover {
  width: 100%;
  min-height: 140px;
  padding: 0;
  margin-bottom: -70px;
  position: relative;
  background-color: var(--light-300);
  border-top: 1px solid var(--border-neutral);
  border-bottom: 1px solid var(--border-neutral);
}

</style>
